import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService } from 'api';

import { AcceptAgreementProps } from 'models/api';

export const acceptAgreement = createAsyncThunk(
	'user/acceptAgreement',
	async (credentials: AcceptAgreementProps, { rejectWithValue }) => {
		try {
			await AccountService.acceptAgreement(credentials);
			return await AccountService.profile();
		} catch (e: any) {
			return rejectWithValue(e?.response.data);
		}
	},
);
